/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpsertClassroomDisFolderViewModel } from "../types/UpsertClassroomDisFolderViewModel.ts";

export const upsertClassroomDisFolderViewModelSchema = z.object({
  title: z.string().nullish(),
  parentFolderId: z.number().int().nullish(),
}) as unknown as ToZod<UpsertClassroomDisFolderViewModel>;
